import { UserModel } from "domains/models/UserModel";
import M5APIs from "m5/M5APIs";
import * as config from "../../../_config";
import { makeAutoObservable, action, computed, observable } from "mobx";
import { M5Doc } from "m5/models/M5Doc";
import { AssessModel } from "domains/models/AssessModel";
import { TaskModel } from "domains/models/TaskModel";
import { EmployeeModel } from "domains/models/EmployeeModel";
import moment from "moment";

class AdviceTimelinePageStore {
  @observable private _containers = [];
  @observable private _task: TaskModel = {
    contents: "",
    created: 0,
    status: "TODO",
    subtype: "EMAIL",
    title: "",
    type: "TASK",
    children: [],
  };
  @observable _isLoading: boolean = false;
  @observable private _employee?: EmployeeModel;
  @observable private _isChecked: boolean = false;
  @observable private _last30dayAvg: number = 0;
  @observable private _quarterAvg: number = 0;
  @observable private _halfAvg: number = 0;
  @observable private _yearAvg: number = 0;
  @observable private _total = 0;
  @observable private _assessList: Array<AssessModel> = [];
  @observable _assess?: AssessModel;
  @observable _isOpenModal: boolean = false;
  @observable _isCloseModal: boolean = false;
  @observable private _period = "last30day";
  @observable private _labels: string[] = [];
  @observable private _scores: any = [];
  @observable private _isGraph: boolean = false;
  @observable private _emogiList: any[] = [];
  @observable private _totalEmoji: number = 0;
  @observable private _maxEmojiCount: number = 0;
  @observable private _minEmojiCount: number = 0;

  @observable private _isMoreBtn: boolean = true;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  async fetchChartData(period: string) {
    this._isLoading = true;

    // let filterPeriod;
    // if (period === "quarter") {
    //   filterPeriod = {
    //     condition: "AND",
    //     field: "created",
    //     compare: "BETWEEN",
    //     value: [moment().subtract(3, "months").valueOf(), moment().valueOf()],
    //   };
    // } else if (period === "half") {
    //   filterPeriod = {
    //     condition: "AND",
    //     field: "created",
    //     compare: "BETWEEN",
    //     value: [moment().subtract(6, "months").valueOf(), moment().valueOf()],
    //   };
    // } else if (period === "year") {
    //   filterPeriod = {
    //     condition: "AND",
    //     field: "created",
    //     compare: "BETWEEN",
    //     value: [moment().subtract(3, "year").valueOf(), moment().valueOf()],
    //   };
    // } else {
    //   filterPeriod = {
    //     condition: "AND",
    //     field: "created",
    //     compare: "BETWEEN",
    //     value: [moment().subtract(1, "month").valueOf(), moment().valueOf()],
    //   };
    // }

    this._scores = [];
    this._labels = [];
    let tempEmogiArr: any[] = [
      {
        emoji: "👍",
        isHover: false,
        count: 0,
      },
      {
        emoji: "⭕",
        isHover: false,
        count: 0,
      },
      {
        emoji: "🙂",
        isHover: false,
        count: 0,
      },
      {
        emoji: "👎",
        isHover: false,
        count: 0,
      },
      {
        emoji: "❌",
        isHover: false,
        count: 0,
      },
      {
        emoji: "😥",
        isHover: false,
        count: 0,
      },
      {
        emoji: "😐",
        isHover: false,
        count: 0,
      },
      {
        emoji: "🤔",
        isHover: false,
        count: 0,
      },
    ];
    this._totalEmoji = 0;
    if (period === "year") {
      for (let i = 0; i < this._assessList.length; i++) {
        if (
          this._assessList[i].subtype === "VISIBLE" &&
          typeof this._assessList[i].userData?.emoticon === "string"
        ) {
          if (
            this._assessList[i].created! < moment().valueOf() &&
            this._assessList[i].created! >
              moment().subtract(1, "year").valueOf()
          ) {
            for (let j = 0; j < tempEmogiArr.length; j++) {
              if (
                this._assessList[i].userData?.emoticon === tempEmogiArr[j].emoji
              ) {
                tempEmogiArr[j].count = tempEmogiArr[j].count + 1;
                this._totalEmoji = this._totalEmoji + 1;
              }
            }
          }
        }
      }

      this._emogiList = tempEmogiArr;

      for (let i = 2; i >= 0; i--) {
        if (i === 0) {
          this._labels = [...this._labels, moment().format("YYYY")];
        } else {
          this._labels = [
            ...this._labels,
            moment().subtract(i, "year").format("YYYY"),
          ];
        }
      }
      let currentSum = 0;
      let lastYearSum = 0;
      let last2yearSum = 0;

      let currentCount = 0;
      let lastYearCount = 0;
      let last2YearCount = 0;

      for (let j = 0; j < this._assessList.length; j++) {
        if (this._assessList[j].subtype === "INVISIBLE") {
          if (
            this._assessList[j].created! < moment().valueOf() &&
            this._assessList[j].created! > moment().startOf("year").valueOf()
          ) {
            currentSum =
              currentSum + Number(this._assessList[j].userData.grade);
            currentCount = currentCount + 1;
          } else if (
            this._assessList[j].created! <
              moment().subtract(1, "year").endOf("year").valueOf() &&
            this._assessList[j].created! >
              moment().subtract(1, "year").startOf("year").valueOf()
          ) {
            lastYearSum =
              lastYearSum + Number(this._assessList[j].userData.grade);
            lastYearCount = lastYearCount + 1;
          } else if (
            this._assessList[j].created! <
              moment().subtract(2, "year").endOf("year").valueOf() &&
            this._assessList[j].created! >
              moment().subtract(2, "year").startOf("year").valueOf()
          ) {
            last2yearSum =
              last2yearSum + Number(this._assessList[j].userData.grade);
            last2YearCount = last2YearCount + 1;
          }
        }
      }
      if (currentCount === 0) {
        currentCount = 1;
      }
      if (lastYearCount === 0) {
        lastYearCount = 1;
      }
      if (last2YearCount === 0) {
        last2YearCount = 1;
      }
      this._scores = [...this._scores, last2yearSum / last2YearCount];
      this._scores = [...this._scores, lastYearSum / lastYearCount];
      this._scores = [...this._scores, currentSum / currentCount];
    } else if (period === "quarter") {
      const quarter = moment().quarter();
      const startOfQuarter = moment()
        .startOf("year")
        .add(3 * quarter - 3, "months");

      for (let i = 0; i < this._assessList.length; i++) {
        if (
          this._assessList[i].subtype === "VISIBLE" &&
          typeof this._assessList[i].userData?.emoticon === "string"
        ) {
          if (
            this._assessList[i].created! <
              startOfQuarter
                .clone()
                .add(2, "months")
                .endOf("month")
                .valueOf() &&
            this._assessList[i].created! >
              startOfQuarter.clone().add(0, "months").startOf("month").valueOf()
          ) {
            for (let j = 0; j < tempEmogiArr.length; j++) {
              if (
                this._assessList[i].userData?.emoticon === tempEmogiArr[j].emoji
              ) {
                tempEmogiArr[j].count = tempEmogiArr[j].count + 1;
                this._totalEmoji = this._totalEmoji + 1;
              }
            }
          }
        }
      }
      this._emogiList = tempEmogiArr;

      for (let i = 2; i >= 0; i--) {
        const month = startOfQuarter
          .clone()
          .add(2 - i, "months")
          .format("MMM");
        this._labels = [...this._labels, month];
      }

      let currentSum = 0;
      let quarter1Sum = 0;
      let quarter2Sum = 0;

      let currentCount = 0;
      let quarter1Count = 0;
      let quarter2Count = 0;

      for (let j = 0; j < this._assessList.length; j++) {
        if (this._assessList[j].subtype === "INVISIBLE") {
          if (
            this._assessList[j].created! <
              startOfQuarter
                .clone()
                .add(2, "months")
                .endOf("month")
                .valueOf() &&
            this._assessList[j].created! >
              startOfQuarter.clone().add(2, "months").startOf("month").valueOf()
          ) {
            currentSum =
              currentSum + Number(this._assessList[j].userData.grade);
            currentCount = currentCount + 1;
          } else if (
            this._assessList[j].created! <
              startOfQuarter
                .clone()
                .add(1, "months")
                .endOf("month")
                .valueOf() &&
            this._assessList[j].created! >
              startOfQuarter.clone().add(1, "months").startOf("month").valueOf()
          ) {
            quarter1Sum =
              quarter1Sum + Number(this._assessList[j].userData.grade);
            quarter1Count = quarter1Count + 1;
          } else if (
            this._assessList[j].created! <
              startOfQuarter
                .clone()
                .add(0, "months")
                .endOf("month")
                .valueOf() &&
            this._assessList[j].created! >
              startOfQuarter.clone().add(0, "months").startOf("month").valueOf()
          ) {
            quarter2Sum =
              quarter2Sum + Number(this._assessList[j].userData.grade);
            quarter2Count = quarter2Count + 1;
          }
        }
      }
      if (currentCount === 0) {
        currentCount = 1;
      }
      if (quarter1Count === 0) {
        quarter1Count = 1;
      }
      if (quarter2Count === 0) {
        quarter2Count = 1;
      }
      this._scores = [...this._scores, quarter2Sum / quarter2Count];
      this._scores = [...this._scores, quarter1Sum / quarter1Count];
      this._scores = [...this._scores, currentSum / currentCount];
    } else if (period === "half") {
      const quarter = moment().quarter();
      const halfYear = quarter <= 2 ? 1 : 2;
      const firstMonthInHalfYear = (halfYear - 1) * 6 + 1;
      const lastMonthInHalfYear = firstMonthInHalfYear + 5;

      for (let i = firstMonthInHalfYear; i <= lastMonthInHalfYear; i++) {
        for (let j = 0; j < this._assessList.length; j++) {
          if (
            this._assessList[j].subtype === "VISIBLE" &&
            typeof this._assessList[j].userData?.emoticon === "string"
          ) {
            if (
              this._assessList[j].created! <
                moment().month(i).endOf("month").valueOf() &&
              this._assessList[j].created! >
                moment().month(i).startOf("month").valueOf()
            ) {
              for (let k = 0; k < tempEmogiArr.length; k++) {
                if (
                  this._assessList[j].userData?.emoticon ===
                  tempEmogiArr[k].emoji
                ) {
                  tempEmogiArr[k].count = tempEmogiArr[k].count + 1;
                  this._totalEmoji = this._totalEmoji + 1;
                }
              }
            }
          }
        }
      }
      this._emogiList = tempEmogiArr;

      for (let i = lastMonthInHalfYear; i >= firstMonthInHalfYear; i--) {
        const month = moment()
          .year(moment().year())
          .month(6 - i)
          .format("MMM");
        this._labels = [...this._labels, month];
      }

      for (let i = lastMonthInHalfYear; i >= firstMonthInHalfYear; i--) {
        let sum = 0;
        let count = 0;
        for (let j = 0; j < this._assessList.length; j++) {
          if (this._assessList[j].subtype === "INVISIBLE") {
            if (
              this._assessList[j].created! <
                moment().month(i).endOf("month").valueOf() &&
              this._assessList[j].created! >
                moment().month(i).startOf("month").valueOf()
            ) {
              sum = sum + Number(this._assessList[j].userData.grade);
              count = count + 1;
            }
          }
        }

        if (count === 0) {
          count = 1;
        }
        this._scores = [...this._scores, sum / count];
      }
    } else {
      for (let i = 0; i < this._assessList.length; i++) {
        if (
          this._assessList[i].subtype === "VISIBLE" &&
          typeof this._assessList[i].userData?.emoticon === "string"
        ) {
          if (
            this._assessList[i].created! >
              moment().subtract(30, "days").valueOf() &&
            this._assessList[i].created! < moment().valueOf()
          ) {
            for (let j = 0; j < tempEmogiArr.length; j++) {
              if (
                this._assessList[i].userData?.emoticon === tempEmogiArr[j].emoji
              ) {
                tempEmogiArr[j].count = tempEmogiArr[j].count + 1;
                this._totalEmoji = this._totalEmoji + 1;
              }
            }
          }
        }
      }
      this._emogiList = tempEmogiArr;

      for (let i = 29; i >= 0; i--) {
        this._labels = [
          ...this._labels,
          moment().subtract(i, "day").format("MM/DD"),
        ];
      }

      for (let i = 29; i >= 0; i--) {
        let sum = 0;
        let count = 0;
        for (let j = 0; j < this._assessList.length; j++) {
          if (this._assessList[j].subtype === "INVISIBLE") {
            if (
              this._assessList[j].created! >
                moment().subtract(i, "day").startOf("day").valueOf() &&
              this._assessList[j].created! <
                moment().subtract(i, "day").endOf("day").valueOf()
            ) {
              sum = sum + Number(this._assessList[j].userData.grade);
              count = count + 1;
            }
          }
        }
        if (count === 0) {
          count = 1;
        }
        this._scores = [...this._scores, sum / count];
      }
      console.log(this._scores);
    }
    tempEmogiArr.sort((a, b) => b.count - a.count);
    this._maxEmojiCount = tempEmogiArr[0].count;
    this._minEmojiCount =
      tempEmogiArr[tempEmogiArr.length - 1].count === 0
        ? 1
        : tempEmogiArr[tempEmogiArr.length - 1].count;
  }

  @action
  async fetchTaskByAssessId(assesId: string) {
    try {
      this._isLoading = true;
      let tempUserList: any = [];
      const res: any = await M5APIs.fetchDocById<TaskModel>(
        assesId,
        config.BUCKET_TASK!,
        "TASK",
        {
          page: 0,
          pageSize: 10,
          fetchChildrenJson: [
            {
              types: "ASSESS",
              page: 0,
              pageSize: 100,
            },
          ],
          where: {
            filters: [
              {
                condition: "AND",
                field: "id",
                compare: "=",
                value: assesId,
              },
            ],
          },
        }
      ).then(async (res) => {
        for (let i = 0; i < res.children?.length; i++) {
          let tempUserIdlist = new Set();
          for (let i = 0; i < res.children?.length; i++) {
            tempUserIdlist.add(res.children[i].userId);
          }
          let userRes = await M5APIs.fetchUsers({
            page: 0,
            pageSize: 200,
            where: JSON.stringify({
              filters: [
                {
                  condition: "AND",
                  field: "meta().id",
                  compare: "IN",
                  value: Array.from(tempUserIdlist),
                },
              ],
            }),
          });
          console.log(userRes);
          tempUserList = userRes.users;
        }
        return res;
      });

      // res.docs.forEach((doc: TaskModel) => {
      let tempChildren: AssessModel[] = [];

      for (let i = 0; i < res.children?.length; i++) {
        const found = tempUserList.find(
          (item: any) => item.id === res.children[i].userId
        );
        console.log(found);
        res.children[i].user = found;
      }

      res.children?.forEach(async (child: any, index: number) => {
        if (res.docs.id === child.parentId) {
          tempChildren.push(child);
        }
      });
      res.docs.children = tempChildren;
      // });

      this._task = res.doc;

      this._task.children = res.children;

      this._isLoading = false;
    } catch (err: any) {
      this._isLoading = false;
      throw err;
    }
  }

  @action
  async fetchAsssessList(user: EmployeeModel) {
    this._isLoading = true;

    const response: any = await M5APIs.fetchDocById(
      user.userData.aggregationId!,
      "",
      "AGGREGATION",
      {
        fetchLinkedIds: true,
      }
    );
    let sumLast30 = 0;
    let sumYear = 0;
    let sumHalf = 0;
    let sumQuarter = 0;

    let countLast30 = 0;
    let countYear = 0;
    let countHalf = 0;
    let countQuarter = 0;

    if (
      response.docs.userData.assessList &&
      response.docs.userData.assessList.length !== 0
    ) {
      response.docs.userData.assessList =
        response.docs.userData.assessList.sort(
          (a: any, b: any) => b.created - a.created
        );
      for (let i = 0; i < response.docs.userData.assessList.length; i++) {
        if (response.docs.userData.assessList[i].subtype === "INVISIBLE") {
          const createTime = response.docs.userData.assessList[i].created!;
          const curYear = moment().year();
          const curMonth = moment().month() + 1;
          //30일 카운트
          if (
            createTime > moment().subtract(1, "month").valueOf() &&
            createTime <= moment().valueOf()
          ) {
            sumLast30 =
              sumLast30 +
              Number(response.docs.userData.assessList[i].userData.grade!);
            countLast30 = countLast30 + 1;
          }

          // 1년 카운트
          let newYDate = new Date(curYear, 0, 1);
          let newYDate2 = new Date(curYear, 11, 31);
          if (
            createTime > moment(newYDate).valueOf() &&
            createTime <= moment(newYDate2).valueOf()
          ) {
            sumYear =
              sumYear +
              Number(response.docs.userData.assessList[i].userData.grade!);
            countYear = countYear + 1;
          }
          // 반기 카운트
          let startMonth = 0;
          let endMonth = 2;
          //전반기 일떄
          if (curMonth < 7) {
            startMonth = 0;
            endMonth = 5;
          }
          //후반기 일때
          else {
            startMonth = 6;
            endMonth = 11;
          }
          let neQDate = new Date(curYear, startMonth, 1);
          let newQDate2 = new Date(curYear, endMonth, 31);
          if (
            createTime > moment(neQDate).valueOf() &&
            createTime <= moment(newQDate2).valueOf()
          ) {
            sumHalf =
              sumHalf +
              Number(response.docs.userData.assessList[i].userData.grade!);
            countHalf = countHalf + 1;
          }
          let startHMonth = 0;
          let endHMonth = 2;
          // 1분기
          if (moment().format("Q") === "1") {
            startHMonth = 0;
            endHMonth = 2;
          }
          // 2분기
          else if (moment().format("Q") === "2") {
            startHMonth = 3;
            endHMonth = 5;
          }
          // 3분기
          else if (moment().format("Q") === "3") {
            startHMonth = 6;
            endHMonth = 8;
          }
          // 4분기
          else {
            startHMonth = 9;
            endHMonth = 11;
          }

          let newHDate = new Date(curYear, startHMonth, 1);
          let newHDate2 = new Date(curYear, endHMonth, 31, 23, 59, 59);
          if (
            createTime > moment(newHDate).valueOf() &&
            createTime <= moment(newHDate2).valueOf()
          ) {
            sumQuarter =
              sumQuarter +
              Number(response.docs.userData.assessList[i].userData.grade!);
            countQuarter = countQuarter + 1;
          }
        }
      }

      this._halfAvg = countHalf === 0 ? 0 : sumHalf / countHalf;
      this._yearAvg = countYear === 0 ? 0 : sumYear / countYear;
      this._quarterAvg = countQuarter === 0 ? 0 : sumQuarter / countQuarter;
      this._last30dayAvg = countLast30 === 0 ? 0 : sumLast30 / countLast30;
    }

    if (response.linkedDocs) {
      for (let i = 0; i < response.docs.userData.assessList.length; i++) {
        for (let j = 0; j < response.linkedDocs?.length; j++) {
          if (
            response.docs.userData.assessList[i].parentId ===
            response.linkedDocs[j].id
          ) {
            response.docs.userData.assessList[i].parents =
              response.linkedDocs[j];
          }
        }
      }

      let tempEmogiArr: any[] = [
        {
          emoji: "👍",
          isHover: false,
          count: 0,
        },
        {
          emoji: "⭕",
          isHover: false,
          count: 0,
        },
        {
          emoji: "🙂",
          isHover: false,
          count: 0,
        },
        {
          emoji: "👎",
          isHover: false,
          count: 0,
        },
        {
          emoji: "❌",
          isHover: false,
          count: 0,
        },
        {
          emoji: "😥",
          isHover: false,
          count: 0,
        },
        {
          emoji: "😐",
          isHover: false,
          count: 0,
        },
        {
          emoji: "🤔",
          isHover: false,
          count: 0,
        },
      ];

      this._totalEmoji = 0;
      for (let i = 0; i < response.docs.userData.assessList.length; i++) {
        if (
          response.docs.userData.assessList[i].subtype === "VISIBLE" &&
          typeof response.docs.userData.assessList[i].userData?.emoticon ===
            "string"
        ) {
          if (
            response.docs.userData.assessList[i].created < moment().valueOf() &&
            response.docs.userData.assessList[i].created >
              moment().subtract(1, "year").valueOf()
          ) {
            for (let j = 0; j < tempEmogiArr.length; j++) {
              if (
                response.docs.userData.assessList[i].userData?.emoticon ===
                tempEmogiArr[j].emoji
              ) {
                tempEmogiArr[j].count = tempEmogiArr[j].count + 1;
                this._totalEmoji = this._totalEmoji + 1;
              }
            }
          }
        }
      }
      this._emogiList = tempEmogiArr;
    }

    if (response) {
      this._assessList = response.docs.userData.assessList;
      this._total = response.total;
      this._isLoading = false;
    }
  }

  @action
  setIsChecked(isChecked: boolean) {
    this._isChecked = isChecked;
  }

  @computed
  get isChecked() {
    return this._isChecked;
  }

  @computed
  get assessList() {
    return this._assessList;
  }
  @computed
  get total() {
    return this._total;
  }

  @computed
  get task() {
    return this._task;
  }

  @computed
  get assess() {
    return this._assess;
  }

  @action
  setEmployee(employee: EmployeeModel) {
    this._employee = employee;
  }

  @action
  setAssess(assess: AssessModel) {
    this._assess = assess;
  }

  @action
  setIsOpenModal(isOpenModal: boolean) {
    this._isOpenModal = isOpenModal;
  }

  @action
  setIsCloseModal(isCloseModal: boolean) {
    this._isCloseModal = isCloseModal;
  }

  @action
  setIsGraph(isGraph: boolean) {
    this._isGraph = isGraph;
  }

  @action
  setPeriod(period: string) {
    this._period = period;
  }

  @action
  setEmogiList(emogiList: any) {
    this._emogiList = emogiList;
  }

  @action
  setIsMoreBtn(isMoreBtn: boolean) {
    this._isMoreBtn = isMoreBtn;
  }

  @computed
  get emogiList() {
    return this._emogiList;
  }

  @computed
  get containers() {
    return this._containers;
  }
  @computed
  get isEmpty() {
    return this._containers.length === 0;
  }
  @computed
  get isOpenModal() {
    return this._isOpenModal;
  }
  @computed
  get employee() {
    return this._employee;
  }

  @computed
  get last30dayAvg() {
    return this._last30dayAvg;
  }

  @computed
  get yearAvg() {
    return this._yearAvg;
  }

  @computed
  get halfAvg() {
    return this._halfAvg;
  }

  @computed
  get quarterAvg() {
    return this._quarterAvg;
  }

  @computed
  get labels() {
    return this._labels;
  }

  @computed
  get scores() {
    return this._scores;
  }

  @computed
  get isMoreBtn() {
    return this._isMoreBtn;
  }

  @computed
  get period() {
    return this._period;
  }

  @computed
  get isGraph() {
    return this._isGraph;
  }

  @computed
  get totalEmoji() {
    return this._totalEmoji;
  }
  @computed
  get isLoading() {
    return this._isLoading;
  }
  @computed
  get maxEmojiCount() {
    return this._maxEmojiCount;
  }
  @computed
  get minEmojiCount() {
    return this._minEmojiCount;
  }
}

export default AdviceTimelinePageStore;
